import { EyeIcon } from '@/Client/Icons';
import { useScanEditingContextSlice } from '@/Client/State';
import { useNavigateToScan } from '@/Client/State/kaiNavigation';
import { pxToRem } from '@/Client/Styles/pxToRem';
import { css } from '@emotion/react';
import { ScopeReportLineItem } from '@kaiizen/kai-reports';
import { COLORS2, LAYOUT2 } from '../../Styles';
import { Button, EditIcon, ProgressIcon, WarningIcon } from '../../Widgets';
import { useScopePrintPreviewContext } from './ScopePrintPreviewContext';

const ACTION_DROPDOWN_STYLE = css`
  background-color: ${COLORS2.alwaysDark.offWhite};
  border-top: solid 1px ${COLORS2.alwaysDark.lightGray};
  border-bottom: solid 1px ${COLORS2.alwaysDark.lightGray};
  padding: ${LAYOUT2.spacing2}px ${LAYOUT2.spacing2}px;

  @media print {
    display: none;
  }
`;

const BUTTON_WRAPPER_STYLE = css`
  display: flex;
  gap: ${LAYOUT2.spacing2}px;
  justify-content: center;

  button {
    flex: 0 0 130px;
    padding: 8px 16px !important;
    font-size: ${pxToRem(11)} !important;
  }
`;

export const LineItemInlineActionDropDown = ({
  item,
}: {
  item: ScopeReportLineItem;
}) => {
  const navigateToScan = useNavigateToScan();
  const { project, latestScan, scanIsEditable } = useScanEditingContextSlice(['project', 'latestScan', 'scanIsEditable']);
  const { currentDropdown, setCurrentDropdown } = useScopePrintPreviewContext();
  const { groupId, taskId } = item;

  const isOpen = currentDropdown?.groupId === groupId && currentDropdown?.taskId === taskId;

  if (!isOpen) return null;

  const isApproved = !!project?.latestApprovedScan;

  const navigateToScopeEditor = async () => {
    if (!latestScan) return;
    navigateToScan({ scanId: latestScan?.id, review: true, taskId });
    setCurrentDropdown(undefined);
  };

  const handleProgressClick = async () => {
    if (!latestScan) return;
    navigateToScan({ scanId: latestScan?.id, groupId, taskId, progress: true });
    setCurrentDropdown(undefined);
  };

  return (
    <tr>
      <td colSpan={7} css={ACTION_DROPDOWN_STYLE}>
        <div css={BUTTON_WRAPPER_STYLE}>
          {isApproved
            ? (
              <>
                {scanIsEditable
                  ? (
                    <Button
                      buttonStyle='yellow'
                      size='small'
                      onClick={navigateToScopeEditor}
                    >
                      <WarningIcon /> Change
                    </Button>
                  )
                  : (
                    <Button buttonStyle='white' size='small' onClick={navigateToScopeEditor}>
                      <EyeIcon /> View
                    </Button>
                  )}
                <Button
                  buttonStyle='blue'
                  size='small'
                  onClick={handleProgressClick}
                >
                  <ProgressIcon size={14} /> Progress
                </Button>
              </>
            )
            : (
              <Button
                buttonStyle='white'
                size='small'
                onClick={navigateToScopeEditor}
              >
                <EditIcon /> Edit
              </Button>
            )}
        </div>
      </td>
    </tr>
  );
};
